import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import MultiSelect from "../../../Forms/Element/MultiSelect";

/**
 * Exibe as filiais.
 */
const BranchMultiSelect = (props) => {
   
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        axiosInstance.get("/main/branches/user", null).then((response) => {
            let options = [];

            for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].status === 'ACTIVE') {
                    options.push(
                        {
                            value: response.data[i].id,
                            label: response.data[i].name
                        }
                    );
                }
            }
            setOptions(options);
        });
    }, []);

    return (
        <MultiSelect
            options={options}
            placeholder={t("select")}
            {...props} />
    )
}

export default BranchMultiSelect;